import {
  WILL_MUST_GET, WILL_MUST_GET_FAILURE, WILL_MUST_GET_SUCCESS,
  WILL_MUST_DOWNLOAD, WILL_MUST_DOWNLOAD_SUCCESS, WILL_MUST_DOWNLOAD_FAILURE,
  WILL_MUST_CSV_DOWNLOAD, WILL_MUST_CSV_DOWNLOAD_SUCCESS, WILL_MUST_CSV_DOWNLOAD_FAILURE,
  WILL_MUST_DELETE, WILL_MUST_DELETE_SUCCESS, WILL_MUST_DELETE_FAILURE
} from './mutation-types'

export default {
  state: {
    willMusts: []
  },
  getters: {
    willMusts: state => {
      return state.willMusts
    }
  },
  actions: {
    [WILL_MUST_GET] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/master/will_musts', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(WILL_MUST_GET_FAILURE, res.data)
          } else {
            commit(WILL_MUST_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [WILL_MUST_DOWNLOAD] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/master/will_musts/download', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(WILL_MUST_DOWNLOAD_FAILURE, res.data)
          } else {
            commit(WILL_MUST_DOWNLOAD_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [WILL_MUST_CSV_DOWNLOAD] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/master/will_musts/csv_download', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(WILL_MUST_CSV_DOWNLOAD_FAILURE, res.data)
          } else {
            commit(WILL_MUST_CSV_DOWNLOAD_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [WILL_MUST_DELETE] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/master/will_musts/remove_pdf', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(WILL_MUST_DELETE_FAILURE, res.data)
          } else {
            commit(WILL_MUST_DELETE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [WILL_MUST_GET_FAILURE] (state, data) {
      console.log('WILL_MUST_GET_FAILURE')
    },
    [WILL_MUST_GET_SUCCESS] (state, data) {
      console.log('WILL_MUST_GET_SUCCESS')
      state.willMusts = data.data
      if (data.callback) {
        data.callback(data.data)
      }
    },
    [WILL_MUST_GET_FAILURE] (state, data) {
      console.log('WILL_MUST_GET_FAILURE')
    },
    [WILL_MUST_DOWNLOAD_SUCCESS] (state, data) {
      console.log('WILL_MUST_GET_SUCCESS')
      if (data.callback) {
        data.callback(data.data)
      }
    },
    [WILL_MUST_CSV_DOWNLOAD_FAILURE] (state, data) {
      console.log('WILL_MUST_CSV_DOWNLOAD_FAILURE')
    },
    [WILL_MUST_CSV_DOWNLOAD_SUCCESS] (state, data) {
      console.log('WILL_MUST_CSV_DOWNLOAD_SUCCESS')
      if (data.callback) {
        data.callback(data.data.data)
      }
    },
    [WILL_MUST_DELETE_FAILURE] (state, data) {
      console.log('WILL_MUST_DELETE_FAILURE')
    },
    [WILL_MUST_DELETE_SUCCESS] (state, data) {
      console.log('WILL_MUST_DELETE_SUCCESS')
      if (data.callback) {
        data.callback(data.data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/will-must.js